<template>
  <div class="row text-center mt-0 mb-0">
    <div class="col-md-12">
      <small class="text-muted d-block text-uppercase font-weight-bold mb-2" style="font-size: 11px; letter-spacing: 0.8px;">
        <i class="fa-solid fa-pen-nib mr-1 text-primary"></i> Neue Signatur zeichnen
      </small>
      <canvas
          id="signature-canvas"
          width="350"
          height="200"
          style="border: 1px solid rgb(208, 208, 208);"
          ref="canvasRef"></canvas>
      <input v-model="formData.digitalSignature" type="hidden"/>
    </div>
  </div>

  <div v-if="existingDigitalSignature">
    <div class="d-flex flex-row justify-content-center align-items-center">
      <div style="width: 350px; margin-bottom: 10px; margin-top: 10px;" class="text-center">
        <small class="text-muted d-block text-uppercase font-weight-bold mb-2"
               style="font-size: 11px;
               letter-spacing: 0.8px;">
          <i class="fa-solid fa-signature mr-1 text-success"></i> Aktuelle Signatur
        </small>
        <img
            class="img-fluid shadow-sm"
            :src="existingDigitalSignature"
            alt="Signature"
            style="width: 100%; height: 150px; object-fit: contain; border: 1px solid #dee2e6; background-color: #f8f9fa; border-radius: 6px; padding: 10px;"
          />
       </div>
    </div>
  </div>

  <div class="d-flex flex-column flex-sm-row justify-content-center align-items-center modal-buttons mt-3 pt-3 border-top w-100 gap-2" style="border-top-color: #eef1f5 !important;">

    <button class="btn btn-soft-red font-weight-bold mr-0 mr-md-3 px-4 w-100 w-sm-auto d-inline-flex align-items-center justify-content-center" style="min-height: 38px;" @click="clearSignature">
      <i class="fa-solid fa-eraser mr-2"></i> {{ $t('general.button.delete') }}
    </button>

    <button class="btn btn-primary font-weight-bold ml-0 ml-md-3 mt-3 mt-md-0 px-4 w-100 w-sm-auto d-inline-flex align-items-center justify-content-center" style="min-height: 38px;" @click="saveSignature">
      <i class="fa-solid fa-floppy-disk mr-2"></i> {{ $t('general.button.save') }}
    </button>

  </div>
</template>

<script setup lang="ts">
import {ErrorToast, SuccessToast} from '@/components/VueToast';
import SignaturePad from 'signature_pad';
import {defineEmits, defineProps, onMounted, ref, toRefs} from 'vue';
import {useI18n} from 'vue-i18n';
import unemployedPrivateCoachingService from "@/api/Unemployed/PrivateCoaching";

const emit = defineEmits(['update:modelValue', 'update:missingDigitalSignature', 'update:submitForm']);
const {t} = useI18n();
const canvasRef = ref<HTMLCanvasElement | null>(null);
const existingDigitalSignature = ref('');
const isLoaded = ref(false);
let signaturePad: any = null;

const props = defineProps({
  documentId: {
    type: String,
    required: true,
  },
  submitForm: {
    type: Boolean,
    required: true,
    default: false,
  },
});

const documentId = toRefs(props)['documentId'];

const formData = ref<any>({
  digitalSignature: '',
  documentId: documentId.value,
});

async function saveSignature() {
  if (signaturePad && !signaturePad.isEmpty()) {
    formData.value.digitalSignature = signaturePad.toDataURL('image/png');
  } else {
    formData.value.digitalSignature = ''; // Clear if empty
  }

  // // 👇 OVDJE LOG
  // console.log('Base64 length:', formData.value.digitalSignature.length);
  //
  // const sizeMB = (formData.value.digitalSignature.length * 3) / 4 / 1024 / 1024;
  // console.log('Signature size MB:', sizeMB.toFixed(2));


  try {
   await unemployedPrivateCoachingService.saveDigitalSignature(
       documentId.value,
       formData.value
   );

    emit('update:submitForm', !props.submitForm);
    SuccessToast(t('general.toasts.save_success'));
  } catch (error) {
    await ErrorToast(error);
  }
}

const clearSignature = () => {
  if (signaturePad) {
    signaturePad.clear();
    formData.value.digitalSignature = '';
  }
};

async function getDocumentData() {
  const {data} = await unemployedPrivateCoachingService.getDigitalSignature(
      documentId.value,
  );

  existingDigitalSignature.value = data.data.digitalSignatureBase64
}

onMounted(async () => {
  await getDocumentData();

  if (canvasRef.value) {
    signaturePad = new SignaturePad(canvasRef.value, {
      backgroundColor: '#fff',
      penColor: 'rgb(0, 0, 0)',
    });
  }

  isLoaded.value = true;
});
</script>

<style scoped>
canvas {
  cursor: crosshair!important;
}

.modal_buttons_container {
  display: flex;
  gap: 165px;
}

.btn-soft-red {
  color: #a51d24;
  background-color: #fce8e6;
  border: 1px solid #f8c2be;
  transition: all 0.15s ease-in-out;
}

.btn-soft-red:hover {
  color: #ffffff;
  background-color: #a51d24;
  border-color: #a51d24;
}

.btn i {
  font-size: 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  vertical-align: middle;
}
</style>

